import { useInView } from "../hooks/useInView";
import { scrollTo } from "../utils/scroll";

export default function Hero() {
  const [heroRef, heroVis] = useInView(0.1);

  const heroStyle = {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#0f2d6b 0%,#1d4ed8 45%,#0d9488 100%)",
    display: "flex" as const,
    alignItems: "center" as const,
    position: "relative" as const,
    overflow: "hidden" as const,
  };

  const containerStyle = {
    maxWidth: 1100,
    margin: "0 auto",
    padding: "120px 20px 60px",
    display: "grid" as const,
    gridTemplateColumns: "1fr 1fr",
    gap: 60,
    alignItems: "center" as const,
    position: "relative" as const,
    zIndex: 1,
  };

  return (
    <div id="hero" ref={heroRef} style={heroStyle}>
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            borderRadius: "50%",
            border: "1px solid rgba(255,255,255,0.08)",
            width: i * 180,
            height: i * 180,
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            pointerEvents: "none",
          }}
        />
      ))}

      <div style={containerStyle}>
        <div
          style={{
            opacity: heroVis ? 1 : 0,
            transform: heroVis ? "translateX(0)" : "translateX(-40px)",
            transition: "all 1s ease",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 50,
              padding: "8px 18px",
              marginBottom: 24,
            }}
          >
            <span
              style={{
                width: 8,
                height: 8,
                background: "#34d399",
                borderRadius: "50%",
              }}
            />
            <span style={{ color: "#99f6e4", fontSize: 13, fontWeight: 500 }}>
              Available for Consultations
            </span>
          </div>

          <h1
            style={{
              fontSize: "clamp(36px,5vw,60px)",
              fontWeight: 800,
              color: "white",
              lineHeight: 1.15,
              marginBottom: 12,
            }}
          >
            Dr. Gaurav
            <br />
            <span style={{ color: "#5eead4" }}>B. Modi</span>
          </h1>

          <p
            style={{
              color: "#bfdbfe",
              fontSize: 18,
              fontWeight: 500,
              marginBottom: 8,
            }}
          >
            MD, DM (Nephrology)
          </p>

          <p
            style={{
              color: "rgba(255,255,255,0.75)",
              fontSize: 15,
              lineHeight: 1.7,
              marginBottom: 32,
              maxWidth: 460,
            }}
          >
            Consultant Nephrologist & Kidney Transplant Physician. World-class
            kidney care with compassion and clinical excellence across
            Ahmedabad.
          </p>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
            <button
              onClick={() => scrollTo("contact")}
              style={{
                background: "linear-gradient(135deg,#0d9488,#34d399)",
                color: "white",
                border: "none",
                fontWeight: 700,
                fontSize: 15,
                padding: "14px 30px",
                borderRadius: 50,
                cursor: "pointer",
                boxShadow: "0 6px 20px rgba(13,148,136,0.4)",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              📅 Book Appointment
            </button>
            <button
              onClick={() => scrollTo("about")}
              style={{
                background: "rgba(255,255,255,0.1)",
                color: "white",
                border: "2px solid rgba(255,255,255,0.35)",
                fontWeight: 600,
                fontSize: 15,
                padding: "14px 30px",
                borderRadius: 50,
                cursor: "pointer",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.18)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.1)";
              }}
            >
              Learn More →
            </button>
          </div>

          <div style={{ display: "flex", gap: 24, marginTop: 36, flexWrap: "wrap" }}>
            {[
              "📍 Shahibaug & Nikol, Ahmedabad",
              "🕐 Mon – Sat Appointments",
            ].map((text, i) => (
              <span
                key={i}
                style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}
              >
                {text}
              </span>
            ))}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            opacity: heroVis ? 1 : 0,
            transform: heroVis ? "translateX(0)" : "translateX(40px)",
            transition: "all 1s ease 0.3s",
          }}
        >
          <div style={{ position: "relative" }}>
            <div
              style={{
                width: 340,
                height: 340,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.06)",
                border: "4px solid rgba(255,255,255,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                overflow: "hidden",
              }}
            >
              <img
                src="/gaurav.png"
                alt="Dr. Gaurav B. Modi"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                bottom: -16,
                right: -16,
                background: "white",
                borderRadius: 18,
                padding: "12px 20px",
                textAlign: "center",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              }}
            >
              <div style={{ fontSize: 24, fontWeight: 800, color: "#1d4ed8" }}>
                10+
              </div>
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>
                Years Experience
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: -16,
                left: -16,
                background: "linear-gradient(135deg,#0d9488,#34d399)",
                borderRadius: 18,
                padding: "12px 20px",
                textAlign: "center",
                color: "white",
                boxShadow: "0 8px 24px rgba(13,148,136,0.35)",
              }}
            >
              <div style={{ fontSize: 24, fontWeight: 800 }}>5000+</div>
              <div style={{ fontSize: 11, fontWeight: 500, opacity: 0.9 }}>
                Patients Treated
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
